/**
 * CustomTaskForm stays mounted when the selected task changes (job edit,
 * create, and template editors keep the list visible beside the form).
 * Skip reset only for late sharingDefaults on the same task — if the
 * selected id changed, always reset or Apply writes the previous task's
 * values onto the newly selected task.
 */
export function shouldResetCustomTaskForm(
  isDirty: boolean,
  previousTaskId: string | undefined,
  nextTaskId: string
): boolean {
  if (previousTaskId !== nextTaskId) {
    return true;
  }
  return !isDirty;
}
